<ng-container *ngIf="real$ | async as real">

<!-- HEADER START -->
<ion-header class="header" mode="md" *ngIf="('restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug) || !clean">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md" style="--padding-start: 5px; --padding-end: 5px;">

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'pen-klub-restavracija' !== real?.slug && 'rozmarin' !== real?.slug && 'restavracija-rozmarin' !== real?.slug && 'bistro-storja' !== real?.slug && 'restavracija-strelec' !== real?.slug && 'restavracija-shambala' !== real?.slug && 'gostilnica-ruj' !== real?.slug && 'grajski-vrt' !== real?.slug && 'hisa-pod-gradom' !== real?.slug && 'restavracija-cool-house' !== real?.slug && 'city-terasa-maribor' !== real?.slug && 'dine-experience' !== real?.slug && 'zeleni-kras' !== real?.slug && 'boccaccio-sentjakob' !== real?.slug && 'gjerkes-estate-of-taste' !== real?.slug && 'gostilna-pec' !== real?.slug && 'bascarsija-ljubljana' !== real?.slug && 'restavracija-most' !== real?.slug && 'pivnica-union' !== real?.slug && 'dvor-jezersek' !== real?.slug  && 'gostilna-na-gradu' !== real?.slug  && 'wonderland' !== real?.slug && 'restavracija-blejski-grad' !== real?.slug && 'castle-restaurant-taggenbrunn' !== real?.slug && 'hotel-plesnik-logarska-dolina' !== real?.slug && 'altroke' !== real?.slug && 'gaudi-naan' !== real?.slug" slot="start" style="padding-left:0px" class="teden-restavracij clickable"><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logo_table42_black.svg"><!--img src="../../assets/logo.svg"--></ion-title>


      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'restavracija-strelec' === real?.slug" slot="start" style="padding-left:0px" class="strelec clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/strelec.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'restavracija-shambala' === real?.slug" slot="start" style="padding-left:0px" class="shambala clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/shambala.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'bistro-storja' === real?.slug" slot="start" style="padding-left:0px" class="storja clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/storja.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'restavracija-rozmarin' === real?.slug" slot="start" style="padding-left:0px" class="rozmarin clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/rozmarin.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'rozmarin' === real?.slug" slot="start" style="padding-left:0px" class="steakhouse clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/rozmarin2.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'pen-klub-restavracija' === real?.slug" slot="start" style="padding-left:0px" class="pen clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/pen.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'gostilnica-ruj' === real?.slug" slot="start" style="padding-left:0px" class="ruj clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/ruj.png"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'grajski-vrt' === real?.slug" slot="start" style="padding-left:0px" class="grajski-vrt clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/grajski-vrt.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'restavracija-cool-house' === real?.slug" slot="start" style="padding-left:0px" class="cool-house clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/cool-house.png"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'city-terasa-maribor' === real?.slug" slot="start" style="padding-left:0px; max-width: 100% !important; " class="city-terasa clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/city-terasa-small.png"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'hisa-pod-gradom' === real?.slug" slot="start" style="padding-left:0px" class="hisa-pod-gradom clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/hisa-pod-gradom.png"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'dine-experience' === real?.slug" slot="start" style="padding-left:0px" class="dine-experience clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/dine.png"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'boccaccio-sentjakob' === real?.slug" slot="start" style="padding-left:0px" class="boccaccio-sentjakob clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/boccaccio.svg"><!--img src="../../assets/logo.svg"--></ion-title>


      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'gjerkes-estate-of-taste' === real?.slug" slot="start" style="padding-left:0px" class="gjerkes clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/gjerkes.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'gostilna-pec' === real?.slug" style="padding-left:0px" class="pec clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/pec.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'bascarsija-ljubljana' === real?.slug" slot="start" style="padding-left:0px" class="bascarsija clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/bascarsija.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'zeleni-kras' === real?.slug" slot="start" style="padding-left:0px" class="koline clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/koline.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <!--ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'dvor-jezersek' === real?.slug" slot="start" style="padding-left:0px" class="dvor-jezersek clickable" ><img src="../../assets/logos/dvor-jezersek.svg"></ion-title-->

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'dvor-jezersek' === real?.slug && this.currentUrl != '/vecerja-na-zajli' && this.currentUrl != '/vip-gourmet-klub'" slot="start" style="padding-left:0px" class="jezersek-akademija clickable" ><img src="../../assets/logos/jezersek-akademija.png"></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'dvor-jezersek' === real?.slug && ( this.currentUrl == '/vecerja-na-zajli' || this.currentUrl == '/vip-gourmet-klub' )" slot="start" style="padding-left:0px" class="jezersek-akademija clickable" ><img src="../../assets/logos/jezersek-dozivetja.png"></ion-title>
      
      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'gostilna-na-gradu' === real?.slug" slot="start" style="padding-left:0px" class="gostilna-na-gradu clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/gostilna-na-gradu-2.png"><!--img src="../../assets/logo.svg"--></ion-title>
      
      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'restavracija-blejski-grad' === real?.slug" slot="start" style="padding-left:0px" class="restavracija-blejski-grad clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/restavracija-blejski-grad.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'pivnica-union' === real?.slug" slot="start" style="padding-left:0px" class="pivnica-union clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/pivnica-union.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'castle-restaurant-taggenbrunn' === real?.slug" slot="start" style="padding-left:0px" class="taggenbrunn clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/taggenbrunn.png"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'restavracija-most' === real?.slug" slot="start" style="padding-left:0px" class="restavracija-most clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/restavracija-most.svg"><!--img src="../../assets/logo.svg"--></ion-title>
      
      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'wonderland' === real?.slug" slot="start" style="padding-left:0px" class="wonderland clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/wonderland.svg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'hotel-plesnik-logarska-dolina' === real?.slug" slot="start" style="padding-left:0px" class="hotel-plesnik clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/hotel-plesnik.png"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'altroke' === real?.slug" slot="start" style="padding-left:0px" class="altroke clickable" ><!--img style="height: 41px;" src="https://www.iedc.si/images/default-source/Alumni/altroke-logo-cr.jpg?sfvrsn=1"--><img src="../../assets/logos/altroke.jpg"><!--img src="../../assets/logo.svg"--></ion-title>

      <ion-title [routerLink]="['/', 'restavracija', real.provider.id, real.slug]" *ngIf="'gaudi-naan' === real?.slug" slot="start" style="padding-left:0px" class="gaudi-naan clickable" ><img src="../../assets/logos/gaudi-naan.jpg"></ion-title>


      <!--ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
      

        <ion-button class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons-->


      <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>
<!-- HEADER END -->


<!-- page content start -->
<ion-content class="fade-in" style="--background: url('/assets/images/strelec_50.jpg') no-repeat center center / cover;" *ngIf="'restavracija-strelec' === real?.slug && clean && !menuPickClean">


    <div style="display: flex; justify-content: flex-end; align-items: flex-end;">
      <app-top-right class="ion-text-end" [mode]="'strelec-landing'" slot="end"></app-top-right>
    </div>

  <!-- Content goes here -->
  <div style="display: flex; justify-content: center; align-items: center; height: 90%">

    <div  style="width: 300px">
      <img style="width: 300px; margin-bottom:50px;" src="../../assets/images/strelec_white.svg">

      <ion-button style="--border-radius: 10px; --background: #FFA500; font-size: 15px; width: 300px; height: 50px;" mode="md" color="light" (click)="menuPickClean=true" >{{ 'SHOP_DETAIL.BTN_BOOK' | translate }}</ion-button>

      <!-- [routerLink]="['/', 'restavracija', real.provider.id, real.slug, 'rezervacija', 'izberi-termin']" -->
      

    </div>
    
  </div>


</ion-content>

<!-- page content start -->
<ion-content class="fade-in" style="--background: url('/assets/images/jaz_by_ana_ros_60.jpg') no-repeat center center / cover;" *ngIf="'jaz-by-me' === real?.slug && clean && !menuPickClean">


    <div style="display: flex; justify-content: flex-end; align-items: flex-end;">
      <app-top-right class="ion-text-end" [mode]="'strelec-landing'" slot="end"></app-top-right>
    </div>

  <!-- Content goes here -->
  <div style="display: flex; justify-content: center; align-items: center; height: 90%">

    <div style="width: 300px; text-align: center;">
      <img style="width: 300px; margin-bottom: 10px;" src="../../assets/logos/jaz-by-ana-ros.png">
      <div style="margin-bottom: 40px; color: white;">by Ana Roš</div>
      <div style="margin-bottom: 40px;  margin-top: 28px; color: white;">Knafljev prehod, Ljubljana</div>
      <div style="margin-bottom: 40px;  margin-top: 28px; color: white;"><a style="color: white; text-decoration: none;" href="tel:+38615476662">{{ 'SHOP_DETAIL.JAZ_PHONE' | translate }}</a>&nbsp;&nbsp;&nbsp;&nbsp;<a style="color: white; text-decoration: none;" href="mailto:jaz@anaros.eu">jaz@anaros.eu</a></div>
      <!--div style="margin-bottom: 40px;  margin-top: 28px; color: white;"><a href="mailto:jaz@anaros.eu">jaz@anaros.eu</a></div-->
      <ion-button style="--border-radius: 10px; --background: #FFA500; font-size: 15px; width: 300px; height: 50px;" mode="md" color="light" (click)="menuPickClean=true" >{{ 'SHOP_DETAIL.BTN_BOOK' | translate }}</ion-button>

      <!-- [routerLink]="['/', 'restavracija', real.provider.id, real.slug, 'rezervacija', 'izberi-termin']" -->
    </div>

    
  </div>


</ion-content>

<ion-content *ngIf="('restavracija-strelec' === real?.slug || 'jaz-by-me' === real?.slug) && menuPickClean">
<app-pick-menu-clean (onBack)="menuPickClean=false; clean=true;" *ngIf="('restavracija-strelec' === real?.slug || 'jaz-by-me' === real?.slug ) && menuPickClean"></app-pick-menu-clean>
</ion-content>

<!-- page content start -->
<ion-content *ngIf="('restavracija-strelec' !== real?.slug && 'jaz-by-me' !== real?.slug) || !clean">
  <ion-grid fixed class="ion-no-padding">
  <ion-grid  class="ion-padding" style="padding-top:10px;">
    <ion-row class="ion-no-padding shop-detail">
      <ion-col  *ngIf="this.currentUrl != '/vecerja-na-zajli' && this.currentUrl != '/vip-gourmet-klub'" size-md="8" size="8"  class="ion-no-padding">
        <h3 class="shop-detail__heading">Jezeršek<!--<span *ngIf="real?.provider.brandName !== real?.name">{{ real?.provider.brandName }} </span>{{ real?.name }}--></h3>
        <h6 class="shop-detail__address">{{ real?.address }}</h6>
        <span style="color: #BD2333; font-size:small;">Kulinarične delavnice in timbildingi</span>
        <!--span *ngIf="real?.slug == 'gostilnica-ruj'" style="color: #BD2333; font-size:x-small;">MICHELIN GUIDE 2022</span><span *ngIf="real?.slug != 'altroke'" style="color: #BD2333; font-size:x-small;">&nbsp;</span-->
      </ion-col>
      

      <ion-col  *ngIf="this.currentUrl == '/vecerja-na-zajli'" size-md="8" size="8"  class="ion-no-padding">
        <h3 class="shop-detail__heading">Večerja na zajli<!--<span *ngIf="real?.provider.brandName !== real?.name">{{ real?.provider.brandName }} </span>{{ real?.name }}--></h3>
        <h6 class="shop-detail__address">RTC Krvavec, Grad 76, 4207 Cerklje na Gorenjskem</h6>
        <span style="color: #BD2333; font-size:small;">Privoščite si nepozabno kulinarično doživetje v separejih kabinske žičnice Krvavec</span>
        <!--span *ngIf="real?.slug == 'gostilnica-ruj'" style="color: #BD2333; font-size:x-small;">MICHELIN GUIDE 2022</span><span *ngIf="real?.slug != 'altroke'" style="color: #BD2333; font-size:x-small;">&nbsp;</span-->
      </ion-col>

      <ion-col  *ngIf="this.currentUrl == '/vip-gourmet-klub'" size-md="8" size="8"  class="ion-no-padding">
        <h3 class="shop-detail__heading">VIP GOURMET KLUB<!--<span *ngIf="real?.provider.brandName !== real?.name">{{ real?.provider.brandName }} </span>{{ real?.name }}--></h3>
        <h6 class="shop-detail__address">Jezeršek doživetja</h6>
        <span style="color: #BD2333; font-size:small;">Nepozabno športno-kulinarično doživetje za  STRASTNE NAVIJAČE in NEUSTRAŠNE UŽIVAČE!</span>
        <!--span *ngIf="real?.slug == 'gostilnica-ruj'" style="color: #BD2333; font-size:x-small;">MICHELIN GUIDE 2022</span><span *ngIf="real?.slug != 'altroke'" style="color: #BD2333; font-size:x-small;">&nbsp;</span-->
      </ion-col>
      
      <!--NAV></NAV-->

      <!--div *ngIf="true" class="shop-detail-rating-container">
        <ion-img style="height:70px;" [src]="'../../assets/awards/michelin_1star_2022_color.png'"></ion-img>
      </div-->

      <ion-col size-md="2" size-sm="0" size="0" class="ion-no-padding">

        <div *ngIf="true" class="shop-detail-rating-container" style="padding-top:0px">

          <span *ngIf="real?.slug === 'city-terasa-maribor'">
              <img *ngIf="true || real?.falstaff" style="height:30px; padding:8px; margin-top:73px" src="../../assets/awards/falstaff.png"/>
              <br/>
          </span>

        </div>
      </ion-col>

      <ion-col size-md="2" size="4" class="ion-no-padding">

        <div *ngIf="false" class="shop-detail-rating-container" style="padding-top:0px">
          <span   *ngIf="false" class="shop-detail-rating-container__rate"><!--{{ real?.selectionItems[0].rating / 10 | number:'1.1-1' }}--></span>
          <span *ngIf="false && real?.slug != 'restavracija-strelec'" class="shop-detail-rating-container__amount"><!--{{ real?.selectionItems[0].numOfRatings }} ocen-->Teden<br/>restavracij<br/><br/>14 - 23. okt.</span>

          <span class="shop-detail-rating-container__amount">

            <span *ngIf="real?.michelin1Star2022 || real?.michelinBib2022 || real?.michelinGuide2022">
              <img  *ngIf="real?.michelin1Star2022" style="height:50px; margin-bottom:11px;" src="../../assets/awards/michelin_1star_2022_color.png"/>
              <img  *ngIf="real?.michelinBib2022" style="height:50px; margin-bottom:11px;" src="../../assets/awards/michelin_bib_2024_color.png"/>
              <img  *ngIf="real?.michelinGuide2022" style="height:50px; margin-bottom:11px;" src="../../assets/awards/michelin_selected_2024_color.png"/>
              <br/>
            </span>

           

            <span *ngIf="'zeleni-kras' == real?.slug">
              <img *ngIf="'zeleni-kras' == real?.slug" style="height:50px; padding:8px;" src="../../assets/awards/zeleni_kras_green.svg"/>
              <br/>
            </span>
           
            

             <span *ngIf="'zeleni-kras' == real?.slug">
              <img *ngIf="'zeleni-kras' == real?.slug" style="height:35px;" src="../../assets/awards/i_feel_slovenia.png"/>
              <br/>
            </span>



            <span *ngIf="'pen-klub-restavracija' == real?.slug">
              <img *ngIf="'pen-klub-restavracija' == real?.slug" style="height:35px;" src="../../assets/awards/chaine.png"/>
              <br/>
            </span>

            <span *ngIf="real?.falstaff">
              <img *ngIf="real?.falstaff" style="height:30px; padding:8px" src="../../assets/awards/falstaff.png"/>
              <br/>
            </span>
            
            <span *ngIf="real?.gaultMillau4 || real?.gaultMillau3 || real?.gaultMillau2 || real?.gaultMillau1">
              <img *ngIf="real?.gaultMillau4" style="height:30px;" src="../../assets/awards/gm_4hats_black.png"/>
              <img *ngIf="real?.gaultMillau3" style="height:30px;" src="../../assets/awards/gm_3hats_black.png"/>
              <img *ngIf="real?.gaultMillau2" style="height:30px;" src="../../assets/awards/gm_2hats_color.png"/>
              <img *ngIf="real?.gaultMillau1" style="height:30px;" src="../../assets/awards/gm_1hat_color.png"/>
              <br/>
            </span>

            

            <span *ngIf="real?.laListe">
              <img *ngIf="real?.laListe" style="height:30px;" src="../../assets/awards/laListe.jpg"/>
              <br/>
            </span>

            <span *ngIf="real?.jre">
              <img *ngIf="real?.jre" style="height:30px; padding-left:18px" src="../../assets/awards/jre.svg"/>
              <br/>
            </span>

            <br/>


          </span>

          
        </div>

      </ion-col>

 

    </ion-row>
  </ion-grid>
  </ion-grid>

  <ion-slides *ngIf="this.currentUrl != '/vecerja-na-zajli' && this.currentUrl != '/vip-gourmet-klub'" pager="false" [options]="slidesOptions4" class="slider">
    <ion-slide class="slide" >
      <ion-img [alt]="1" class="shop-detail__img" [src]="'/assets/images/akademija1.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="2" class="shop-detail__img" [src]="'/assets/images/akademija2.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="3" class="shop-detail__img" [src]="'/assets/images/akademija3.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="4" class="shop-detail__img" [src]="'/assets/images/akademija4.jpg'" ></ion-img>
    </ion-slide>
  </ion-slides>

  <ion-slides *ngIf="this.currentUrl == '/vecerja-na-zajli'" pager="false" [options]="slidesOptions4" class="slider">
    <ion-slide class="slide" >
      <ion-img [alt]="1" class="shop-detail__img" [src]="'/assets/images/zajla1.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="2" class="shop-detail__img" [src]="'/assets/images/zajla2.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="3" class="shop-detail__img" [src]="'/assets/images/zajla3.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="4" class="shop-detail__img" [src]="'/assets/images/zajla4.png'" ></ion-img>
    </ion-slide>
  </ion-slides>

  <ion-slides *ngIf="this.currentUrl == '/vip-gourmet-klub'" pager="false" [options]="slidesOptions4" class="slider">
    <ion-slide class="slide" >
      <ion-img [alt]="1" class="shop-detail__img" [src]="'/assets/images/vip1.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="2" class="shop-detail__img" [src]="'/assets/images/vip2.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="3" class="shop-detail__img" [src]="'/assets/images/vip5.jpg'" ></ion-img>
    </ion-slide>
    <ion-slide class="slide" >
      <ion-img [alt]="4" class="shop-detail__img" [src]="'/assets/images/vip4.jpg'" ></ion-img>
    </ion-slide>
  </ion-slides>



  <!--ion-slides *ngIf="real.getOrderedImages().length === 1" pager="false" [options]="slidesOptions1" class="slider">
    <ion-slide class="slide" *ngFor="let image of real.getOrderedImages()">
      <ion-img [alt]="image.title" class="shop-detail__img" [src]="( image.fileName | ppImage )" ></ion-img>
    </ion-slide>
  </ion-slides>

  <ion-slides *ngIf="real.getOrderedImages().length === 2" pager="false" [options]="slidesOptions2" class="slider">
    <ion-slide class="slide" *ngFor="let image of real.getOrderedImages()">
      <ion-img [alt]="image.title" class="shop-detail__img" [src]="( image.fileName | ppImage )" ></ion-img>
    </ion-slide>
  </ion-slides>

  <ion-slides *ngIf="real.getOrderedImages().length === 3" pager="false" [options]="slidesOptions3" class="slider">
    <ion-slide class="slide" *ngFor="let image of real.getOrderedImages()">
      <ion-img [alt]="image.title" class="shop-detail__img" [src]="( image.fileName | ppImage )" ></ion-img>
    </ion-slide>
  </ion-slides>

  <ion-slides *ngIf="real.getOrderedImages().length > 3" pager="false" [options]="slidesOptions4" class="slider">
    <ion-slide class="slide" *ngFor="let image of real.getOrderedImages()">
      <ion-img [alt]="image.title" class="shop-detail__img" [src]="( image.fileName | ppImage )" ></ion-img>
    </ion-slide>
  </ion-slides-->

  <!--<ion-slides ngIf="real.getOrderedImageFiles().length === 1" pager="false" [options]="slidesOptions" class="slider">
    <ion-slide class="slide" *ngFor="let imageFile of real.getOrderedImageFiles()">
      <ion-img class="shop-detail__img" [src]="( imageFile | ppImage )" ></ion-img>
    </ion-slide>
  </ion-slides>-->

  <!--ion-slides pager="false" [options]="slidesOptions" class="slider">
    <ion-slide class="slide" *ngFor="let pic of real?.gallery">
      <ion-img class="shop-detail__img" [src]="( pic.document?.fileName || real?.avatar?.document?.fileName) | ppImage)" ></ion-img>
    </ion-slide>
  </ion-slides-->

<!--ion-button  fill="outline" [routerLink]="['../']">Spoznajte nas</ion-button>
<ion-button  fill="outline" [routerLink]="['meni']">Meni</ion-button-->
<!--ion-button  [routerLink]="['meni']">Ocena in mnenja</ion-button-->

  <ion-grid fixed class="ion-no-padding">
  
    <div id="menu" class="tabs-menu">
    
      <div class="tabs" style="margin-left:0px; margin-top:0px;">
        <ion-button  *ngIf="this.currentUrl != '/vecerja-na-zajli' &&  this.currentUrl != '/vip-gourmet-klub'" [routerLink]="['/restavracija/', real.provider.id, real.slug]" fragment="menu" class="tabs__btn" [class.tabs__btn--active]="currentRoute === ''" mode="ios" fill="clear">Aktualne delavnice</ion-button>
        <ion-button  *ngIf="this.currentUrl == '/vecerja-na-zajli' || this.currentUrl == '/vip-gourmet-klub'" [routerLink]="['/restavracija/', real.provider.id, real.slug]" fragment="menu" class="tabs__btn" [class.tabs__btn--active]="currentRoute === ''" mode="ios" fill="clear">Prihajajoči termini</ion-button>

        <!--ion-button *ngIf="real?.suppliers" [routerLink]="['/restavracija/', real.provider.id, real.slug, 'jedilni-list']" fragment="menu" class="tabs__btn" [class.tabs__btn--active]="currentRoute === 'jedilni-list'" mode="ios" fill="clear">{{ 'SHOP_DETAIL.TABS.MENU' | translate }}</ion-button-->
        <ion-button *ngIf="real?.provider?.slug !== 'jezersek'" [routerLink]="['/restavracija/', real.provider.id, real.slug, 'ocene']" fragment="menu" class="tabs__btn" [class.tabs__btn--active]="currentRoute === 'ocene'" mode="ios" fill="clear">{{ 'SHOP_DETAIL.TABS.RATINGS' | translate }}</ion-button>
      </div>

      <div *ngIf="currentRoute === 'jedilni-list'" class="subtabs" style="margin-left:5px;">
        <!--ion-button class="subtabs__btn" mode="ios" size="small" fill="clear">{{ 'SHOP_DETAIL.SUBTABS.MENUS' | translate }}</ion-button-->
        <ion-button (click) ="scrollToAnchor('popularDishes')" *ngIf="real?.suppliers" class="subtabs__btn" mode="ios" size="small" fill="clear">{{ 'SHOP_DETAIL.SUBTABS.POPULAR_DISHES' | translate }}</ion-button>
        <ion-button (click) ="scrollToAnchor('aLaCarte')" *ngIf="real?.suppliers" class="subtabs__btn" mode="ios" size="small" fill="clear">{{ 'SHOP_DETAIL.SUBTABS.A_LA_CARTE' | translate }}</ion-button>
        <ion-button (click)="scrollToAnchor('wineList')" *ngIf="real?.wineList" class="subtabs__btn" mode="ios" size="small" fill="clear">{{ 'SHOP_DETAIL.SUBTABS.WINE_LIST' | translate }}</ion-button>
      </div>
    
    </div>

    <app-exposed *ngIf="currentRoute === ''" [zajla]="zajla" [vip]="vip" [open$]="open$" [real]="real"></app-exposed>
    <app-menu *ngIf="currentRoute === 'jedilni-list'" [anchor$]="anchor$" [real]="real"></app-menu>
    <app-ratings *ngIf="currentRoute === 'ocene'" [real]="real"></app-ratings>
 

  </ion-grid>


  <!--ion-grid>
      <ion-row class="ion-align-items-start">
          <ion-col class="ion-align-self-end ion-text-end" style="border:1px solid red;">

            <div class="ion-float-right" style="width: 50px; border:1px solid green;">bar</div></ion-col>

          <ion-col style="border:1px solid red;"><div style="border:1px solid green;">bar</div></ion-col>
      </ion-row>
  </ion-grid-->




</ion-content>



<ion-footer mode="md" *ngIf="!clean && real?.availableForBooking && true || pickSlotActive">
  <ion-toolbar  class="ion-no-padding">
    <ion-button [color]="('restavracija-strelec' !== real?.slug || !clean)?'primary':'secondary'" [routerLink]="['/', 'restavracija', real.provider.id, real.slug, 'rezervacija', 'izberi-termin']" [queryParams]="( real?.slug === 'hotel-plesnik-logarska-dolina' || real?.slug === 'gaudi-naan' || real?.slug === 'altroke' ) ? { from: '2024-10-11' } : {}" expand="full" class="btn--large ion-no-margin bottom-btn">{{ 'SHOP_DETAIL.BTN_BOOK' | translate }}&nbsp;<ion-icon style="color: white" name="calendar-outline"></ion-icon>
  
  </ion-button>

  <!--a href="tel:{{real?.phone1}}"><ion-button color="secondary" expand="full" class="btn--large ion-no-margin">Pokliči&nbsp;<ion-icon style="color: white" name="call-outline"></ion-icon>
  </ion-button></a-->

  </ion-toolbar>
</ion-footer>


  
</ng-container> 

